import { HomeLandingSection } from "@/components/sections/home-landing-section";
import { Seo } from "@/components/seo/seo";
import { useSiteContent, useSiteShared } from "@/config/use-site-content";
import { useLocale } from "@/i18n/locale-context";
import {
  organizationJsonLd,
  personJsonLd,
  websiteJsonLd,
} from "@/lib/structured-data";

export function HomePage(): JSX.Element {
  const { locale } = useLocale();
  const content = useSiteContent();
  const shared = useSiteShared();

  return (
    <>
      <Seo
        description={content.pages.home.description}
        jsonLd={[
          personJsonLd(shared, content),
          organizationJsonLd(shared, content),
          websiteJsonLd(shared, content),
        ]}
        locale={locale}
        pathWithoutLocale="/"
        title={content.pages.home.title}
      />
      <HomeLandingSection
        closing={content.home.closing}
        hero={content.home.hero}
        proof={content.home.proof}
        timeline={content.home.timeline}
      />
    </>
  );
}
